import options from './left.component';

export default {
    selector: 'dtNavbarLeft',
    options
};



// WEBPACK FOOTER //
// ./app/common/navbar/left/index.js